import React from 'react';
import PropTypes from 'prop-types';

function ContactUsInfoWidget(props) {
    if(!props?.title && !props?.descriptions && !props?.items) return null;

    return (
        <div data-test-id="contactusinfo-wr" className={"widget widget-contactusinfo" + (props?.dark ? " bg-dark" : "")}>
            <div className="container-xl row mx-auto p-0">
                <div className="col-12">
                    {props?.title ? <p data-test-id="contactusinfo-title" className={(props?.dark ? "text-white " : "") + "text-medium text-sm-small text-bold mb-4"}>{props.title}</p> : null}
                    {props?.descriptions ? <p data-test-id="contactusinfo-description" className={(props?.dark ? "text-white " : "") + "text-medium text-sm-small mb-4"}>{props.descriptions}</p> : null}
                    {
                        props?.items ?
                            <ul className="list-none">
                                {
                                    props.items.map((item, index) => {
                                        return (<li data-test-id={"contactusinfo-el-" + index} key={index} className={"text-medium text-sm-small mb-1" + (props?.dark ? " text-white" : "")}>{item.text}</li>)
                                    })
                                }
                            </ul>
                            : null
                    }
                </div>
            </div>
        </div>
    )
}

ContactUsInfoWidget.propTypes = {
    title: PropTypes.string,
    descriptions: PropTypes.string,
    additional_text: PropTypes.string,
    button_text: PropTypes.string,
    path: PropTypes.string,
    img: PropTypes.string,
    position: PropTypes.number,
    widget: PropTypes.string,
    className: PropTypes.string,
}

export default ContactUsInfoWidget;
